
// src/helpers/strip-html.js

export default function stripHtml(html) {
  return html.replace(/<br>/g, '\n')
    .replace(/<li[^>]*>/ig, '* ')
    .replace(/<\/li>/ig, '\n')
    .replace(/<\/?[^>]+>/g, '')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&')
    .replace(/&nbsp;/g, ' ')
}



// WEBPACK FOOTER //
// ./src/helpers/strip-html.js